/**
 * timezoneMap — ÚNICA fuente país→zona horaria y listado de zonas
 * seleccionables. Reemplaza 5 mapas inline con drift real (uno tenía 7
 * países sin BR, otro 6) y 2 listas hardcodeadas de dropdown.
 *
 * Consumidores: creación de org (stripeWebhook), adapters de calendario
 * (getActiveAdaptersForTenant en functions y server), oauth de Google
 * Calendar, alertas programadas (generateAlerts), whitelist del
 * PATCH /organizations/:orgId, dropdowns de timezone (org en GeneralTab,
 * bot en BotConfig) y el script de migración one-time.
 *
 * TRES COPIAS BYTE-IDÉNTICAS de contenido (extensión según runtime):
 *   - functions/utils/timezoneMap.cjs   (CJS nativo)
 *   - server/src/utils/timezoneMap.cjs  (ESM importa CJS por interop)
 *   - src/utils/timezoneMap.js          (webpack/CRA interopera module.exports)
 * El gate pre-commit (functions/scripts/check-shared-module-parity.js) falla
 * si divergen. Editá SIEMPRE las tres juntas. Sintaxis CJS pura y sin
 * imports a propósito: es lo único que los tres runtimes cargan igual.
 */

// Mapa canónico país (ISO-2) → zona IANA. Best-guess por país: en países
// multi-zona (MX/BR/US) se usa la zona principal — corregible a mano con el
// selector de la org (GeneralTab) o del bot (BotConfig).
const COUNTRY_TIMEZONES = {
  CL: 'America/Santiago',
  MX: 'America/Mexico_City',
  AR: 'America/Argentina/Buenos_Aires',
  CO: 'America/Bogota',
  PE: 'America/Lima',
  US: 'America/New_York',
  ES: 'Europe/Madrid',
  BR: 'America/Sao_Paulo',
};

// Labels de display por zona (presentacional, no pasa por i18n — igual que
// las listas hardcodeadas que reemplaza).
const TIMEZONE_LABELS = {
  'America/Santiago': 'Chile (Santiago) 🇨🇱',
  'America/Mexico_City': 'México (CDMX) 🇲🇽',
  'America/Argentina/Buenos_Aires': 'Argentina (Buenos Aires) 🇦🇷',
  'America/Bogota': 'Colombia (Bogotá) 🇨🇴',
  'America/Lima': 'Perú (Lima) 🇵🇪',
  'America/New_York': 'EE.UU. (New York) 🇺🇸',
  'Europe/Madrid': 'España (Madrid) 🇪🇸',
  'America/Sao_Paulo': 'Brasil (São Paulo) 🇧🇷',
  UTC: 'UTC (Universal)',
};

// Zonas seleccionables (dropdowns org/bot + whitelist del PATCH): DERIVADAS
// del mapa de países + UTC — nunca una lista paralela. Regla estructural: el
// selector cubre al menos los mismos países que la inferencia, y no puede
// driftear de ella porque es la misma fuente.
const SELECTABLE_TIMEZONES = [...new Set(Object.values(COUNTRY_TIMEZONES))]
  .concat('UTC')
  .map((value) => ({ value, label: TIMEZONE_LABELS[value] || value }));

/**
 * País ISO-2 → zona IANA, o null si no está mapeado. Devuelve null a
 * propósito (no un default): TODOS los consumidores hacen
 * `x || getTimezoneFromCountry(c) || <default propio>` — el default es
 * decisión del caller, no del mapa.
 */
function getTimezoneFromCountry(countryCode) {
  return COUNTRY_TIMEZONES[countryCode] || null;
}

module.exports = {
  COUNTRY_TIMEZONES,
  TIMEZONE_LABELS,
  SELECTABLE_TIMEZONES,
  getTimezoneFromCountry,
};
